<app-page>
    <app-title>{{ 'orders_for_later' | translate }}</app-title>
    <app-orders [ordersModel]="ordersForLaterModel"></app-orders>
</app-page>
